import Blurable from './Blurable';

export default Blurable;
